module.exports = require("cross-fetch/polyfill");


//////////////////
// WEBPACK FOOTER
// external "cross-fetch/polyfill"
// module id = 20
// module chunks = 0